export default {
    state: {
        description: false
    },
    mutations: {
        update(state, description) {
            state.description = description
        }
    },
    actions: {
        begin(ctx) { // { commit, getters, dispatch }  
        /* Description */
        let description = document.getElementById('description')
        
        if(!ctx.getters.description) { description.style.height = "auto"; description.classList.add('active') }
        else { description.style.height = "108px"; description.classList.remove('active') }
                            
        ctx.commit('update', !ctx.getters.description) /* меняем состояніе */
        }
    },
    getters: {
        description(state) {
            return state.description
        }
    }
}